import { createSvgIcon } from '@mui/material/utils';
import React, { memo } from 'react';

const SvgIcon = createSvgIcon(
  [
    <circle key='0' fill='#FF9800' cx='12' cy='12' r='12' />,
    <path
      key='1'
      fill='#FFFFFF'
      d='M11.9,17.4h0.1c0.8,0,1.4,0.6,1.4,1.4v0.1c0,0.8-0.6,1.4-1.4,1.4h-0.1c-0.8,0-1.4-0.6-1.4-1.4v-0.1
	C10.6,18,11.2,17.4,11.9,17.4z M12,3.8L12,3.8c0.8,0,1.4,0.6,1.4,1.4v8.7c0,0.8-0.6,1.4-1.4,1.4h0c-0.8,0-1.4-0.6-1.4-1.4V5.2
	C10.6,4.4,11.2,3.8,12,3.8z'
    />,
  ],
  'TransportConditionWarningIcon'
);

const TransportConditionWarningIcon = function (props) {
  return <SvgIcon {...props} />;
};

export default memo(TransportConditionWarningIcon);
